import React, { useState, useEffect } from 'react';
import { CheckCircle, XCircle, X } from 'lucide-react';

const Toast = ({ 
  message, 
  type = 'success', 
  duration = 3000, 
  onClose 
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  const handleClose = () => {
    setVisible(false);
    if (onClose) {
      setTimeout(onClose, 300); // Allow animation to complete
    }
  };

  if (!visible) return null;

  return (
    <div 
      className={`fixed bottom-4 right-4 flex items-center p-4 rounded-md shadow-lg transition-all duration-300 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'
      } ${
        type === 'success' ? 'bg-green-50 border-l-4 border-green-500' : 
        type === 'error' ? 'bg-red-50 border-l-4 border-red-500' : 
        'bg-blue-50 border-l-4 border-blue-500'
      }`}
      role="alert"
    >
      <div className="flex items-center">
        {type === 'success' ? (
          <CheckCircle className="w-5 h-5 text-green-500 mr-3" />
        ) : type === 'error' ? (
          <XCircle className="w-5 h-5 text-red-500 mr-3" />
        ) : (
          <div className="w-5 h-5 mr-3 rounded-full bg-blue-500 text-white flex items-center justify-center">
            i
          </div>
        )}
        <p className={`text-sm font-medium ${
          type === 'success' ? 'text-green-800' : 
          type === 'error' ? 'text-red-800' : 
          'text-blue-800'
        }`}>
          {message}
        </p>
      </div>
      <button 
        onClick={handleClose}
        className={`ml-4 p-1 rounded-full hover:bg-white ${
          type === 'success' ? 'text-green-500 hover:text-green-700' : 
          type === 'error' ? 'text-red-500 hover:text-red-700' : 
          'text-blue-500 hover:text-blue-700'
        }`}
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Toast;